import React from 'react';

const Header = () => {
    return ( 
        <header>
          <img src='./../header.jpg' alt="header"/>
          <h1>Video Recommendation</h1>
          <h5>Favorite Youtube Videos List</h5>
        </header>
     );
}
 
export default Header;